import React from 'react'
import { Link } from 'react-router-dom'
import '../signup/SignUp.css'


const SignUp = () => {
  return (
    <div className='login-section w-100 '>
      <div className='login-box position-relative d-flex flex-wrap align-content-center justify-content-center'>
        <h6 className='text-center'>Sign up</h6>
        <div className='login-form w-100'>
            <div className=' btn-box w-100'>
                <Link rel='stylesheet' to="/email-verify" className='btn btn-border w-100 d-block'>Sign up with email</Link>
                <Link rel='stylesheet' to="/email-verify" className='btn btn-border w-100 d-block'>Continue with Google</Link>
                <Link rel='stylesheet' to="/email-verify" className='btn btn-border w-100 d-block'>Continue with Apple ID</Link>
            </div>
            <p className='text-center'>Already have an account? <Link rel='stylesheet' to="/home">Log in</Link></p>
        </div>
      </div>
    </div>
  )
}

export default SignUp
